
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import './registerServiceWorker';
import 'datatables.net-bs4';
import 'datatables.net-responsive-bs4';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'bootstrap-switch/dist/css/bootstrap3/bootstrap-switch.min.css';
import 'bootstrap-switch/dist/js/bootstrap-switch.min.js';
import 'sweetalert2/dist/sweetalert2.min.css';


import AlertPlugin from './plugins/alert.js';
import ThemeSwitcher from '@/components/ThemeSwitcher.vue'
createApp(App)
  .use(store)
  .use(router)
  .use(AlertPlugin)
  .component('ThemeSwitcher', ThemeSwitcher)
  .mount('#app');


